// ============================================================
// THE SQUAD MODE MARK (Squad Mode stage 7, ruled 2026-10-23): linked
// chevrons in the team's livery, wherever a person is named - the order
// strip's seat, the actor's summary, the muster's chip, the map's name
// pill. Who wears it: a brother in Squad Mode (waiting to enter is not).
//
// Pure. Zero React dependency.
// ============================================================
import type { Combatant } from '../roster/types';

/** In Squad Mode, read off his state or his projection (both carry `killTeam`). */
export const inSquadMode = (s: { killTeam?: { on?: true } } | null | undefined): boolean => !!s?.killTeam?.on;

/** The ids of everyone on the roster in Squad Mode: one set for the map's figures. */
export function squadIdsOf(roster: readonly Combatant[]): ReadonlySet<string> {
  return new Set(roster.filter((c) => inSquadMode(c.state)).map((c) => c.id));
}
